import { useWindowSize } from '@/hooks';
import { Space } from 'antd';
import { CSSProperties, ReactNode } from 'react';
import { SpaceProps } from 'antd/lib/space';

interface SpaceForButtonInterface extends SpaceProps {
  children: ReactNode;
  justifyContent?: CSSProperties['justifyContent'];
  flexDirection?: CSSProperties['flexDirection'];
}

export default function SpaceForButton({
  children,
  justifyContent,
  flexDirection,
  ...props
}: SpaceForButtonInterface) {
  const { isMobile } = useWindowSize();

  return (
    <Space
      {...props}
      style={{
        width: '100%',
        justifyContent,
        flexDirection,
        ...(!isMobile ? { flexFlow: 'wrap' } : {}),
        ...props.style,
      }}
      direction={isMobile ? 'vertical' : 'horizontal'}
    >
      {children}
    </Space>
  );
}
